import { Link, useLocation } from "react-router";
import { inboxWords as words } from "./inbox-copy";

function useInboxBase(){
  const {pathname}=useLocation();
  return pathname.startsWith("/admin/teaching")?"/admin/teaching":pathname.startsWith("/student")?"/student":"/instructor";
}
/** The course's inbox, in the person's own shell. */
export function CourseInboxLink({courseId}:{courseId:string}) {
  const base=useInboxBase();
  return <Link className="w-fit text-ui font-semibold text-primary" to={`${base}/inbox?course=${encodeURIComponent(courseId)}`}>{words.openInbox}</Link>;
}
